// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W8D6v","top":"styles_top__32B6Q"};